import { FARMS_ARR } from '@context/constants';

export const getFarmListForProvider = (provider: string): IFarmPair[] => {
  return FARMS_ARR[provider] || [];
};
